var _defs, _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daaea8;}.cls-2{fill:#845161;}.cls-3{fill:#69303a;}.cls-4{fill:#00214e;}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-5{stroke:#00214e;}.cls-6{stroke:#daaea8;}.cls-7{fill:#de8276;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.72,166.8c-1.57-3.12-3.09-6.28-4.55-9.45-2.86-6.2-5.54-12.55-6.74-19.27-3.89-21.68,7.32-45.32,23.41-59.22,22.9-19.77,55.34-27.24,80.57-44.78a34.59,34.59,0,0,1-12.9,21.76c11.81-9.1,47,5.89,58,11.51a116.3,116.3,0,0,1,44.94,40.08,73.87,73.87,0,0,0-37.51-4.8c9.88,9.57,20.16,19.78,23.9,33C270.11,122.85,241.8,129,231,148.05c-6.93,12.2-6.83,27.06-11,40.47-4.4,14.2-16.27,23.22-30.23,27-10.52,2.88-31.22,4.18-40.75-2-2.89-1.87-5-4.73-6.94-7.55A318.87,318.87,0,0,1,118.72,166.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 129.75,
    cy: 170.77,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 135.61,
    cy: 169.77,
    r: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.34,294a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38a46.35,46.35,0,0,0,12.78-15.09c4-7.55,5.32-15.89,5.38-24.39,0-2.81-.06-5.63-.14-8.45s-.2-5.81-.23-8.72q-.06-4.75-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.39,13.29.07,2.25v.33l12.1,4.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.67,258.19l-1.54.16a51.49,51.49,0,0,1-40.67-14.65l-27.58-32.51c-.09-2.9,0,0,0-2.91q-.06-4.75-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.41,139.06a17.1,17.1,0,0,0-5.64,10.69c-2.09,19.53,5.14,42.58,7.15,62.14l36.42,26.86a51.48,51.48,0,0,0,42.29,8.94c5.87-1.39,9.59-2.29,12.24-7,5.12-9,17.69-39.79,18.51-61.51.23-6.17.08-15.57-3.72-20.82-1.85-2.55-2.8-2.61-2.13-6.21.69-3.76,1.68-7.48,2.51-11.21a52,52,0,0,0,1-16.45c-.55-5-.53-9.44-1.06-14.53-.26-2.47-1.36-13.28-1.36-13.28-6.35,9.56-17.81,14.58-28.41,17.88-14.42,4.48-29.43,6.67-44.05,10.43C162.47,127.52,146.8,131.12,138.41,139.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.62,154.13c6.1.05,6.1,9.38,0,9.43h-.27c-6.11-.05-6.11-9.38,0-9.43h.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234.31,151.28c5.67,0,5.67,8.7,0,8.75h-.25c-5.66-.05-5.66-8.71,0-8.75h.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.09,199.08a29.76,29.76,0,0,0,18.54,9.69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167.42,142.94a80.34,80.34,0,0,1,28.13-.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.47,143a55.64,55.64,0,0,1,17.45-1.21"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M291.34,294a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38,23.55,16.76,55.69,27.33,83.49,14.82,6.62-3,12.7-7.84,16.3-14.06Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M198.42,182.25a3.4,3.4,0,0,0,2.11,6.38"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.83,153.21c2.49,9.55,4.56,19,6.93,28.57a7,7,0,0,1,.3,2.72c-.43,2.75-3.7,3.88-6.42,4.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar1.d4140edf479e90525e470c610a6e97fd.svg";
export { ForwardRef as ReactComponent };